import { border } from 'src/UI/theme'

export function Separator() {
  return <hr style={{ border: 0, borderBottom: border, width: '100%' }} />
}
